import {
  ADMIN_DASHBOARD_COMPARE_PERIOD,
  ADMIN_DASHBOARD_COMPARE_SHORTCUT,
  ADMIN_DASHBOARD_PERIOD,
  LINK_CLICK_ANALYTICS_PERIOD,
  LINK_CLICK_ANALYTICS_SELECTED_LINK,
  QUESTIONNAIRE_ANALYTICS_PERIOD,
} from '../../../../constants'
import { createPersistMiddleware } from '../../../../store/createPersistMiddleware'

export const persistPeriodMiddleware = createPersistMiddleware({
  selector: (state) => state.adminDashboard.period,
  storageKey: ADMIN_DASHBOARD_PERIOD,
  fallback: [null, null],
})

export const persistComparePeriodMiddleware = createPersistMiddleware({
  selector: (state) => state.adminDashboard.comparePeriod,
  storageKey: ADMIN_DASHBOARD_COMPARE_PERIOD,
  fallback: [null, null],
})

export const persistCompareShortcutMiddleware = createPersistMiddleware({
  selector: (state) => state.adminDashboard.compareShortcut,
  storageKey: ADMIN_DASHBOARD_COMPARE_SHORTCUT,
  fallback: null,
})

export const persistQuestionnaireStatsPeriodMiddleware = createPersistMiddleware({
  selector: (state) => state.adminDashboard.questionnaireStatsPeriod,
  storageKey: QUESTIONNAIRE_ANALYTICS_PERIOD,
  fallback: [null, null],
})

export const persistLinkClickStatsPeriodMiddleware = createPersistMiddleware({
  selector: (state) => state.adminDashboard.linkClickStatsPeriod,
  storageKey: LINK_CLICK_ANALYTICS_PERIOD,
  fallback: [null, null],
})

export const persistLinkClickSelectedKeyMiddleware = createPersistMiddleware({
  selector: (state) => state.adminDashboard.linkClickSelectedKey,
  storageKey: LINK_CLICK_ANALYTICS_SELECTED_LINK,
  fallback: 'all',
})
